var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.class_list},[(_vm.snackbar_options.type == 'default')?_c('Default'):_vm._e(),(_vm.snackbar_options.type == 'error')?_c('Error',{on:{"dismiss":_vm.dismiss}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }